// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__acp0e","breadcrumbLink":"Breadcrumbs_breadcrumbLink__5iMeA","separator":"Breadcrumbs_separator__JQe3X","current":"Breadcrumbs_current__A5zpN"};